<template>
  <footer class="app-footer">
    <span class="footer-copy">&copy; 2026 The Fourth Seagull Pty Ltd</span>
    <span class="footer-sep">·</span>
    <a href="/guides" class="footer-link">Guides</a>
    <span class="footer-sep">·</span>
    <a href="/privacy-policy" class="footer-link">Privacy Policy</a>
    <span class="footer-sep">·</span>
    <a href="/terms-and-conditions" class="footer-link">Terms &amp; Conditions</a>
  </footer>
</template>

<style scoped>
.app-footer {
  width: 100%;
  padding: 16px 24px;
  text-align: center;
  font-size: 0.8rem;
  color: rgba(0, 0, 0, 0.4);
  background: transparent;
}

.footer-sep {
  margin: 0 8px;
  color: rgba(0, 0, 0, 0.25);
}

.footer-link {
  color: rgba(0, 0, 0, 0.4);
  text-decoration: none;
}

.footer-link:hover {
  color: rgba(0, 0, 0, 0.65);
  text-decoration: underline;
}
</style>
